<template>
	<div class="teaming-tiptap-slash-commands">
		<div class="teaming-tiptap-slash-commands__items" v-if="items.length">
			<div
				class="teaming-tiptap-slash-commands__item"
				:class="{ 'teaming-tiptap-slash-commands__item--selected': index === selectedIndex }"
				v-for="( item, index ) in translatedItems"
				:key="`slash-command-${ index }`"
				@click="selectItem( index )"
			>
				<div class="teaming-tiptap-slash-commands__icon"><FontAwesomeIcon :icon="item.icon" /></div>
				<div class="teaming-tiptap-slash-commands__text">{{ item.title }}</div>
			</div>
		</div>
		<div v-else>
			<div class="teaming-tiptap-slash-commands__item">
				<div class="teaming-tiptap-slash-commands__text">
					{{ $t( "common.TeamingTiptapSlashCommands_noMatch" )}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TeamingTiptapSlashCommands",

	props: {
		items: {
			type: Array,
			required: true,
		},

		command: {
			type: Function,
			required: true,
		},
	},

	data() {
		return {
			selectedIndex: 0,
		};
	},

	watch: {
		items() {
			this.selectedIndex = 0;
		},
	},

	computed: {
		translatedItems() {
			const { $t, } = this;
			const titleMap = {
				topic: $t( "common.TeamingTiptapSlashCommands_topic" ),
				actionitem: $t( "common.TeamingTiptapSlashCommands_actionItem" ),
				decision: $t( "common.TeamingTiptapSlashCommands_decision" ),
			};
			return this.items.map( item => {
				return {
					...item,
					title: titleMap[ item.key ] || item.key,
				};
			} );
		},
	},

	methods: {
		// eslint-disable-next-line vue/no-unused-properties
		onKeyDown( { event, } ) {
			if ( event.key === "ArrowUp" ) {
				this.upHandler();
				return true;
			}

			if ( event.key === "ArrowDown" ) {
				this.downHandler();
				return true;
			}

			if ( event.key === "Enter" ) {
				this.enterHandler();
				return true;
			}

			return false;
		},

		upHandler() {
			this.selectedIndex = ( ( this.selectedIndex + this.items.length ) - 1 ) % this.items.length;
		},

		downHandler() {
			this.selectedIndex = ( this.selectedIndex + 1 ) % this.items.length;
		},

		enterHandler() {
			this.selectItem( this.selectedIndex );
		},

		selectItem( index ) {
			const item = this.items[ index ];

			if ( item ) {
				this.command( item );
			}
		},
	},
};
</script>

<style lang="scss">
.teaming-tiptap-slash-commands {
	min-width: 10.9375rem;

	position: relative;
	overflow: hidden;

	@include font-and-line-for(0);
	padding: 0.5rem;
	background: $teaming-tiptap-slash-commands-background-color;
	border: 0.0625rem solid $teaming-tiptap-slash-commands-border-color;
	border-radius: 0.5rem;
	box-shadow: 0 0.1875rem 0.375rem 0.0625rem rgba(33, 45, 99, 0.1), 0 1.3125rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2);
}

.teaming-tiptap-slash-commands__items {
	display: flex;
	flex-direction: column;
}

.teaming-tiptap-slash-commands__item {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;

	padding: 0.5rem 0.5rem;

	background: transparent;
	border-radius: 0.5rem;
}

.teaming-tiptap-slash-commands__icon {
	color: $teaming-tiptap-slash-commands-item-icon-color;
}

.teaming-tiptap-slash-commands__text {
	color: $teaming-tiptap-slash-commands-item-text-color;
}

.teaming-tiptap-slash-commands__item--selected {
	background: $teaming-tiptap-slash-commands-selected-item-background-color;

	.teaming-tiptap-slash-commands__icon {
		color: $teaming-tiptap-slash-commands-selected-item-icon-color;
	}

	.teaming-tiptap-slash-commands__text {
		color: $teaming-tiptap-slash-commands-selected-item-text-color;
	}
}
</style>
